module.exports = __webpack_public_path__ + "site_static/img/mall1.202a897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall1.png
// module id = Qh1M
// module chunks = 0